import React from "react";
var __jsx = React.createElement;
import useIsMobile from "@hooks/useIsMobile";
var OilServiceCenter = function OilServiceCenter(_ref) {
  var section = _ref.section;
  var content = section.content,
    title = section.title;
  var isMobile = useIsMobile();
  var bannerContent = /*#__PURE__*/React.createElement("div", {
    className: "bg-white px-4 py-6 md:p-8 rounded-xl"
  }, /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    src: isMobile ? content.image_mobile : content.image,
    alt: title || "service center",
    className: "w-full h-auto block object-cover rounded-xl md:rounded-none"
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "px-3 pb-6 md:px-6 md:pb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-xl overflow-hidden md:max-w-[1200px] md:mx-auto md:pt-12 md:pb-8"
  }, title && /*#__PURE__*/React.createElement("h2", {
    className: "text-xl md:text-3xl font-bold text-[#1B2035] md:text-center mb-6 md:mb-8"
  }, title), content.link ? /*#__PURE__*/React.createElement("a", {
    href: content.link,
    className: "block no-underline"
  }, bannerContent) : bannerContent));
};
export default OilServiceCenter;